import type {DrawingStyle, Jam} from '../model'
import {JAMS_PALETTE} from '../model'

export const jamsToStyle = (jams: Jam[]): DrawingStyle => ({
  fillRule: 'nonzero',
  fill: '#333',
  fillOpacity: 0.9,
  stroke: [
    {
      width: 4,
      palette: jams.map(jam => ({color: JAMS_PALETTE[jam.type]?.color, count: jam.count})),
    },
    {
      width: 6,
      palette: jams.map(jam => ({
        color: JAMS_PALETTE[jam.type]?.border,
        count: jam.count,
      })),
    },
    {width: 10, color: '#fff'},
  ],
})
